import {
    formatterTime
} from '@/util/util'



export const customerInfoTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    viewBtn: false,
    menuWidth: 'max-content',
    // labelWidth: '200',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "合同签订时间",
            prop: "pactTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: true,
            viewVisdiplay: false,
            // editVisdiplay: true,
            hide: true,
            span: 13
        }, {
            label: "成单编号",
            prop: "signNumber",
            type: 'input',
            width: "190",
            viewVisdiplay: false,
            hide: true,
            span: 13
        },
        {
            label: "客户档案号",
            prop: "fileNumber",
            width: "150",
            hide: true,
            type: "input",
            viewVisdiplay: false,
            span: 13
        },
        {
            label: "金蝶系统编号",
            prop: "kingdeeNumber",
            width: "150",
            hide: true,
            type: "input",
            viewVisdiplay: false,
            span: 13
        },
        {
            label: "客户姓名",
            prop: "name",
            search: true,
            type: "input",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入客户姓名"

            }],
            span: 13
        },
        {
            label: "客户电话",
            prop: "mobile",
            search: true,
            type: "input",
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入客户电话"

            }],
            span: 13
        },
        // {
        //     label: "客户地址",
        //     prop: "address",
        //     type: "input",
        //     hide: true,
        //     span: 13
        // },
        {
            label: '省份',
            prop: 'provinceName',
            hide: true,
            formsolt: true,
            span: 13
        }, {
            label: '城市',
            prop: 'cityName',
            hide: true,
            formsolt: true,
            span: 13
        }, {
            label: '地区',
            prop: 'areaName',
            hide: true,
            formsolt: true,
            span: 13
        },
        {
            label: "客户地址",
            placeholder: "请输入详细地址",
            prop: "address",
            type: "input",
            formsolt: true,
            search: true,
            rules: [{
                required: false,
                trigger: "blur",
                message: "请输入客户地址"
            }],
            formatter: function (row) {
                let a = row.provinceName + row.cityName + row.areaName + row.address
                if (a != 0) {
                    return a
                }
            },
            span: 18
        },
        {
            label: '客户地址标记',
            prop: 'provincesPoInt',
            span: 24,
            solt: true,
            hide: true,
            formsolt: true,
            // rules: [{
            //     required: true,
            //     trigger: "change",
            //     message: "请选择地址"

            // }],
        },

        {
            label: "其他人联系电话",
            prop: "otherMobile",
            type: "input",
            hide: true,
            span: 13
        },
        {
            label: "其他联系人与客户关系",
            prop: "relation",
            type: "input",
            hide: true,
            span: 13
        },
        {
            label: "渠道名称",
            prop: "shopName",
            type: "input",
            // formsolt: true,
            hide: true,
            span: 13
        },
        {
            label: "渠道电话",
            prop: "shopMobile",
            type: "input",
            // formsolt: true,
            hide: true,
            span: 13
        },
        {
            label: '系统类别',
            prop: 'firstClassifyName',
            type: 'input',
            hide: true,
            span: 13,
            // formsolt: true
        },
        {
            label: '系统大类',
            prop: 'firstClassifyId',
            type: 'input',
            hide: true,
            span: 13,
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false,
            // formsolt: true
        },
        {
            label: '系统小类',
            prop: 'secondClassifyId',
            type: 'input',
            hide: true,
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false,
            // formsolt: true,
            span: 13

        },
        {
            label: "主机品牌、型号",
            prop: "brandAndType",
            hide: true,
            type: "input",
            span: 13
        },
        {
            label: "系统配置",
            prop: "config",
            type: "input",
            hide: true,
            span: 13
        },
        {
            label: "主机安装时间",
            prop: "installTime",
            type: "datetime",
            hide: true,
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: true,
            // editVisdiplay: false,
            span: 13
        },
        {
            label: "服务状态",
            prop: "serviceStatus",
            type: "input",
            hide: true,
            formsolt: true,
            formatter: function (row) {
                let serviceStatus = []
                for (let i of row.services) {
                    serviceStatus.push(i.serviceStatus)
                }
                return serviceStatus[0]
            },
            span: 13
        },
        {
            label: "服务人员",
            prop: "servicePeople",
            type: "select",
            hide: true,
            formsolt: true,
            formatter: function (row) {
                let servicePeople = []
                for (let i of row.services) {
                    if (i.servicePeople != "null(null)") {
                        servicePeople.push(i.servicePeople)
                    }
                }
                return servicePeople[0]
            },
            span: 13
        },
        {
            label: "安装人员",
            prop: "installStaffName",
            type: "select",
            search: false,
            formsolt: true,
            hide: true,
            span: 13
        },
        {
            label: "主机调试时间",
            prop: "debugTime",
            type: "datetime",
            hide: true,
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: true,
            // editVisdiplay: false,
            span: 13
        },
        {
            label: "调试人员",
            prop: "debugStaffName",
            formsolt: true,
            type: "select",
            hide: true,
            span: 13
        },
        {
            label: "清洗年检记录",
            prop: "gatherPlans",
            hide: true,
            span: 24,
            solt: true,
            formsolt: true
        },
        {
            label: "工程进度",
            prop: "planName",
            type: "input",
            addVisdiplay: false,
            viewVisdiplay: false,
            editVisdiplay: false,
            hide: true,
            span: 13
        },
        {
            label: "工程进度:",
            prop: "planId",
            type: "input",
            hide: true,
            formsolt: true,
            span: 13
        },
        {
            label: "更新人",
            prop: "updateBy",
            addVisdiplay: false,
            search: false,
            type: "input",
            span: 13
        },
        {
            label: "是否购买延保协议",
            prop: "isBuyPact",
            type: "radio",
            dicData: [{
                label: '是',
                value: 'YES'
            }, {
                label: '否',
                value: 'NO'
            }],
            hide: true,
            span: 13
        },

        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false,
            span: 13,
            formatter: function (row) {
                if (row.updateTime != null && row.updateTime != '' && row.updateTime != undefined) {
                    return row.updateTime = row.updateTime * 1
                }
            }
        },
        {
            label: "更新时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: false,
            hide: true,
            viewVisdiplay: false,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};